import * as React from "react";
import { Alert } from "components/bootstrap";
const NoSearchResult = ({ children, className = void 0 }) => /* @__PURE__ */ React.createElement(Alert, { className: `${className != null ? className : ""} no-bm` }, children || "No data available.");
export default NoSearchResult;
